import { FormControl, FormGroup, Validators } from '@angular/forms';

import { DigicodeAanmakenForm } from './digicode-aanmaken.model';
import { Password } from './password';
import { CreatePasswordValidator } from './create-password.validators';

export class DigicodeAanmakenService {
    public static createDigicodeAanmakenFormGroup(): FormGroup<DigicodeAanmakenForm> {
        return new FormGroup({
            username: new FormControl<string>('', {
                validators: [
                    Validators.required,
                    Validators.minLength(6),
                    Validators.maxLength(64),
                    Validators.pattern('[a-zA-Z0-9\\.@_-]*')
                ]
            }),
            password: new FormControl<string>('', {
                validators: [
                    Validators.required,
                    Validators.minLength(Password.minLength),
                    Validators.maxLength(Password.maxLength),
                    CreatePasswordValidator.passwordComplexity,
                    CreatePasswordValidator.passwordNotEqualToValidatePassword,
                    CreatePasswordValidator.passwordSpacePosition,
                    CreatePasswordValidator.passwordForbiddenCharacters
                ]
            }),
            validatePassword: new FormControl<string>('', {
                validators: [Validators.required, CreatePasswordValidator.validatePasswordNotEqualToPassword]
            })
        });
    }
}
